import { render } from "./Composicao.vue?vue&type=template&id=2cfda8dd&scoped=true"
import script from "./Composicao.vue?vue&type=script&lang=js"
export * from "./Composicao.vue?vue&type=script&lang=js"

import "./Composicao.vue?vue&type=style&index=0&id=2cfda8dd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfda8dd"]])

export default __exports__